import React from "react";
import { Card, Select, Input, Typography, Row, Col, Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

const OfferCodificationSection = ({
    clientBrands,
    handleBrandChange,
    selectedBrand,
    isEditMode,
    marketingId,
    typeOfOffers,
    formOfOffers,
    handleAddNewTypeOfOffer,
    handleAddNewFormOfOffer,
    setOfferModalProps,
    typeOfOffer,
    formOfOffer,
    setSelectedProduct,
    setSelectedVariation,
    selectedProduct,
    selectedVariation,
    products,
    productVariations,
    handleProductChange,
    nextOfferNumber,
    startingNumber,
    setStartingNumber,
    codeOffer,
    setCodeOffer,
    setTypeOfOffer,
    setFormOfOffer,
    setSelectedParcelInsertVariations,
    selectedParcelInsertVariations,
    allProductVariations,
}) => {
  return (
    <Card 
      id="offer-codification-section" 
      style={{ width: '100%' }}
      title={<Typography.Title level={5}>Offer Codification</Typography.Title>}
    >
      <Row gutter={[16, 16]}>
        <Col lg={8} sm={12} xs={24}>
          <div style={{ marginBottom: 9 }}>
            <Typography.Text strong>Brand</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={clientBrands.map(option => ({
              label: option.label,
              value: option.value
            }))}
            onChange={(value) => {
              const selectedOption = clientBrands.find(opt => opt.value === value);
              handleBrandChange(selectedOption);
            }}
            placeholder="Choose brand"
            value={selectedBrand ? selectedBrand.value : undefined}
            disabled={isEditMode && marketingId}
          />
        </Col>
        <Col lg={8} sm={12} xs={24}>
          <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography.Text strong>Type of Offer</Typography.Text>
            <Button
              type="primary"
              size="small"
              icon={<PlusCircleOutlined />} 
              onClick={() => {
                setOfferModalProps({
                  title: "Type of Offer",
                  onSubmit: handleAddNewTypeOfOffer,
                  fieldLabels: ["Type of Offer", "Type Code"],
                });
              }}
              data-bs-toggle="modal"
              data-bs-target="#add-two-fields-modal"
            >
              Add New
            </Button>
          </div>
          <Select
            style={{ width: '100%' }}
            options={typeOfOffers.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={typeOfOffer ? typeOfOffer.value : undefined}
            onChange={(value) => {
              const selectedOption = typeOfOffers.find(opt => opt.value === value);
              setTypeOfOffer(selectedOption);
            }}
            placeholder="Select Type of Offer"
            disabled={isEditMode && marketingId}
          />
        </Col>

        <Col lg={8} sm={12} xs={24}>
          <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography.Text strong>Form of Offer</Typography.Text>
            <Button
              type="primary"
              size="small"
              icon={<PlusCircleOutlined />} 
              onClick={() => {
                setOfferModalProps({
                  title: "Form of Offer",
                  onSubmit: handleAddNewFormOfOffer,
                  fieldLabels: ["Form of Offer", "Form Code"],
                });
              }}
              data-bs-toggle="modal"
              data-bs-target="#add-two-fields-modal"
            >
              Add New
            </Button>
          </div>
          <Select
            style={{ width: '100%' }}
            options={formOfOffers.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={formOfOffer ? formOfOffer.value : undefined}
            onChange={(value) => {
              const selectedOption = formOfOffers.find(opt => opt.value === value);
              setFormOfOffer(selectedOption);
            }}
            placeholder="Select Form of Offer"
            disabled={isEditMode && marketingId}
          />
        </Col>
      </Row>
      {/* Product Variation Section */}
      {typeOfOffer?.label.toUpperCase() === "MAILING" && (
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col md={12} xs={24}>
            <div style={{ marginBottom: 8 }}>
              <Typography.Text strong>Product</Typography.Text>
            </div>
            <Select
              style={{ width: '100%' }}
              options={products.map(option => ({
                label: option.label,
                value: option.value
              }))}
              value={selectedProduct ? selectedProduct.value : undefined}
              onChange={(value) => {
                const selectedOption = products.find(opt => opt.value === value);
                setSelectedProduct(selectedOption);
                handleProductChange(selectedOption);
              }}
              placeholder="Select Product"
              disabled={isEditMode && marketingId}
            />
          </Col>
          <Col md={12} xs={24}>
            <div style={{ marginBottom: 8 }}>
              <Typography.Text strong>Product Variation</Typography.Text>
            </div>
            <Select
              style={{ width: '100%' }}
              options={productVariations.map(option => ({
                label: option.label,
                value: option.value
              }))}
              value={selectedVariation ? selectedVariation.value : undefined}
              onChange={(value) => {
                const selectedOption = productVariations.find(opt => opt.value === value);
                setSelectedVariation(selectedOption);
              }}
              placeholder="Select product variation"
              notFoundContent={selectedProduct
                ? "No product variations available."
                : "Please select a product first."}
              disabled={isEditMode && marketingId}
            />
          </Col>
          {selectedProduct &&
            selectedVariation &&
            typeOfOffer &&
            formOfOffer && (
              <>
                {!(nextOfferNumber || marketingId) && (
                  <Col lg={12} sm={12} xs={24}>
                    <div style={{ marginBottom: 8 }}>
                      <Typography.Text strong>Code Offer Starting Number</Typography.Text>
                    </div>
                    <Input
                      value={startingNumber}
                      onChange={(e) => setStartingNumber(e.target.value)}
                      placeholder="Enter Starting Number"
                    />
                  </Col>
                )}
                <Col lg={12} sm={12} xs={24}>
                  <div style={{ marginBottom: 8 }}>
                    <Typography.Text strong>Code Offer</Typography.Text>
                  </div>
                  <Input
                    value={codeOffer}
                    readOnly
                    placeholder="Generated Code Offer"
                    disabled={isEditMode}
                  />
                </Col>
              </>
            )}
        </Row>
      )}

      {typeOfOffer?.label.toUpperCase() === "PARCEL INSERT" && (
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col span={24}>
            <div style={{ marginBottom: 8 }}>
              <Typography.Text strong>Product Variations</Typography.Text>
            </div>
            <Select
              style={{ width: '100%' }}
              mode="multiple"
              options={allProductVariations.map(option => ({
                label: option.label,
                value: option.value
              }))}
              value={selectedParcelInsertVariations ? selectedParcelInsertVariations.map(option => option.value) : []}
              onChange={(values) => {
                const selectedOptions = values.map(value => 
                  allProductVariations.find(opt => opt.value === value)
                );
                setSelectedParcelInsertVariations(selectedOptions);
              }}
              placeholder="Select product variations"
              disabled={isEditMode && marketingId}
              maxTagCount="responsive"
            />
          </Col>
          <Col span={24} style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 8 }}>
              <Typography.Text strong>Code Offer</Typography.Text>
            </div>
            <Input
              value={codeOffer}
              onChange={(e) => setCodeOffer(e.target.value)}
              placeholder="Enter Code Offer"
              disabled={marketingId}
            />
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default OfferCodificationSection;
